import ApiService from './ApiService';

const OptionsService = {
  async fetchOptions(data) {
    return ApiService.customRequest({
      url: `/options`,
      data,
      method: 'POST',
      headers: {
        'x-request-public-key': process.env.VUE_APP_FARMADOMICILIOS_CLIENT_KEY
      }
    });
  }
};
export default OptionsService;
